import React from 'react';

import { FormattedMessage } from 'react-intl';

import { loginConnector } from 'depop/connectors';

const LoginLink = ({ openLogin, ...props }) =>
  <a onClick={openLogin} {...props}>
    <FormattedMessage
      id="app.loginLabel"
      description="Login Label"
      defaultMessage="Login"
    />
  </a>;

export default loginConnector(LoginLink);



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/LoginLink.js